import { render, staticRenderFns } from "./SearchDocuments.vue?vue&type=template&id=4ec14bac&scoped=true&"
import script from "./SearchDocuments.vue?vue&type=script&lang=js&"
export * from "./SearchDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SearchDocuments.vue?vue&type=style&index=0&id=4ec14bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec14bac",
  null
  
)

export default component.exports